export const NYL_IDV_FLOW_KEY = 'NYL_IDV_FLOW';

export const IDV_FLOW_REGISTER = 'register';
export const IDV_FLOW_UPDATE = 'update';

export const setIdvFlow = (flow) => {
  if (!flow) {
    return;
  }
  try {
    sessionStorage.setItem(NYL_IDV_FLOW_KEY, flow);
  } catch (e) {
    // sessionStorage unavailable
  }
};

export const getIdvFlow = () => {
  try {
    return sessionStorage.getItem(NYL_IDV_FLOW_KEY) || null;
  } catch (e) {
    return null;
  }
};

export const clearIdvFlow = () => {
  try {
    sessionStorage.removeItem(NYL_IDV_FLOW_KEY);
  } catch (e) {
    // sessionStorage unavailable
  }
};
